/* ─── Skeleton ─── */
export function SkeletonRow({ idx }: { idx: number }) {
  const imageOnRight = idx % 2 !== 0;
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: imageOnRight ? "1fr 480px" : "480px 1fr",
        minHeight: 420,
        borderRadius: 24,
        overflow: "hidden",
        border: "1px solid #EAEAF0",
      }}
    >
      <div
        style={{
          order: imageOnRight ? 2 : 1,
          background: "#EDEDF5",
        }}
      />
      <div
        style={{
          order: imageOnRight ? 1 : 2,
          padding: "56px 64px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 16,
          background: "#FFFFFF",
        }}
      >
        <div
          style={{
            height: 10,
            width: 80,
            background: "#EDEDF5",
            borderRadius: 4,
          }}
        />
        <div
          style={{
            height: 32,
            width: "70%",
            background: "#EDEDF5",
            borderRadius: 8,
          }}
        />
        <div
          style={{
            height: 2,
            width: 40,
            background: "#EDEDF5",
            borderRadius: 99,
          }}
        />
        <div
          style={{
            height: 14,
            width: "90%",
            background: "#EDEDF5",
            borderRadius: 4,
          }}
        />
        <div
          style={{
            height: 14,
            width: "75%",
            background: "#EDEDF5",
            borderRadius: 4,
          }}
        />
        <div
          style={{
            height: 14,
            width: "60%",
            background: "#EDEDF5",
            borderRadius: 4,
          }}
        />
        <div
          style={{
            height: 48,
            width: 160,
            background: "#EDEDF5",
            borderRadius: 99,
            marginTop: 8,
          }}
        />
      </div>
    </div>
  );
}
